import Button from "./Button";
import PropTypes from "prop-types";
import { useEffect } from "react";

const Modal = ({
  title,
  positiveButtonNode,
  negativeButtonNode,
  positiveButtonHandler,
  modalSize,
  show,
  setShow,
  children,
  disableButtons = false,
}) => {
  useEffect(() => {
    const handleCloseOnEsc = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        e.preventDefault();
        if (!disableButtons) setShow(false);
      }
    };

    if (show) {
      document.body.classList.add("overflow-hidden");
      document.addEventListener("keydown", handleCloseOnEsc);
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
      document.removeEventListener("keydown", handleCloseOnEsc);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, disableButtons]);

  const handleCloseModal = () => setShow(false);

  return (
    <div
      className={`modal m-0 p-0 ${show ? "d-block show" : "d-none fade"}`}
      tabIndex="-1"
    >
      <div
        className="overlay position-fixed vw-100 vh-100 bg-dark bg-opacity-10"
        role="button"
        onClick={!disableButtons ? handleCloseModal : null}
      ></div>
      <div className={`modal-dialog shadow-lg modal-${modalSize}`}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={!disableButtons ? handleCloseModal : null}
            ></button>
          </div>
          <div className="modal-body">{children}</div>
          {positiveButtonNode && (
            <div className="modal-footer d-flex justify-content-between">
              <Button
                onClick={handleCloseModal}
                className="btn-secondary"
                disabled={disableButtons}
              >
                {negativeButtonNode}
              </Button>
              <Button
                onClick={positiveButtonHandler}
                className="btn-primary text-white"
                disabled={disableButtons}
              >
                {positiveButtonNode}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  title: PropTypes.string,
  positiveButtonNode: PropTypes.node,
  negativeButtonNode: PropTypes.node,
  positiveButtonHandler: PropTypes.func,
  modalSize: PropTypes.string,
  show: PropTypes.bool,
  setShow: PropTypes.func,
  children: PropTypes.node,
};

export default Modal;
